import { useMemo } from 'react'

export function useMemoByValues<T extends Record<string, any>>(x: T): T {
  const values = Object.values(x)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => x, values)
}
